var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 109,
    viewBox: "0 0 118 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.7324 0H61.157L82.5213 27.3133L94.7324 0ZM23.5213 0L35.7324 27.3133L57.0968 0H23.5213ZM59.1269 10.3818L42.886 31.1429H75.3677L59.1269 10.3818ZM101.493 4.63737L89.6445 31.1429H118L101.493 4.63737ZM16.7611 4.63737L0 31.1429H28.6093L16.7611 4.63737ZM31.3855 38.9286H0.253763L56.7923 109H56.9268L31.3855 38.9286ZM86.8683 38.9286L61.327 109H61.4615L118 38.9286H86.8683ZM77.7506 38.9286H40.5032L59.1269 89.5357L77.7506 38.9286Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamant);
export default __webpack_public_path__ + "static/media/diamant.3c50079344c6ee06bd55d4a775cb7107.svg";
export { ForwardRef as ReactComponent };